import { useEffect, useState } from 'react';

const useFeatureToggles = (key: string) => {
  const [enabledFeatures, setEnabledFeatures] = useState<string[]>([]);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const features = (query.get(key)?.split(',') ?? []) as string[];

    setEnabledFeatures(features);
  }, [setEnabledFeatures, key]);

  const isEnabled = (feature: string) => {
    return enabledFeatures.includes(feature);
  };

  return {
    isEnabled,
  };
};

export default useFeatureToggles;
